// The TYPED per-pillar result shapes — P3's contract, in one import.
//
// `attach-result.js` is the read every consumer makes; the per-pillar modules
// are what a pillar lane authors and what a widget's props are typed against.
// The value codecs are exported too, because the round-trip suites and any
// future pillar's shape module are their only callers.

export * from "./attach-value-codec.js";
export * from "./attach-result.js";
export * from "./authored-fields.generated.js";
export * from "./authored.shape.js";
export * from "./flights.shape.js";
export * from "./hotels.shape.js";
export * from "./nutrition.shape.js";
export * from "./web-search.shape.js";
export * from "./workouts.shape.js";
